import React, { useEffect } from 'react'
import { useAdminStore } from '../../../store/userStore'
import { Outlet, useNavigate } from 'react-router-dom'

const AdminProtectedRouteUserType = ({ userType = [] }) => {
    const navigate = useNavigate();
    const { adminInfo } = useAdminStore(state => state)
    const adminUserType = adminInfo?.type ? adminInfo?.type : ''

    useEffect (() => {
        // if (adminInfo?.type !== userType) {
        if (!userType.includes(adminUserType)) {
            window.alert('작성 권한이 없습니다.');
            navigate(-1);
        }
    }, [adminInfo, userType, navigate]);

    // if (adminInfo?.type !== userType) {
    if (!userType.includes(adminUserType)) {
        return null
    }
    else {
        return <Outlet />;
    }

}

export default AdminProtectedRouteUserType